module.exports = __webpack_public_path__ + "img/__icon_PODKONTENEROWA_STANDARD_45.70f74671.svg";